<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

appStore.initTheme()
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `app-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
.app-grey-mode {
  filter: grayscale(100%);
}

.logoutModal {
  .ant-modal-content {
    .ant-modal-body {
      .ant-modal-confirm-btns {
        display: flex;

        .ant-btn {
          flex: 1;
          height: 2.5rem;

          &.ant-btn-primary {
            margin-left: 0.75rem;
          }
        }
      }
    }
  }
}
</style>
